import React from "react";
import {css} from "emotion";
import {boxStyles, colors, textSizes} from "../styles/theme";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const IconTextGeneric = ({icon, text}) => {
  let finalIcon = icon;

  return (
    <div className={container + ' icon-text'}>
      <FontAwesomeIcon className="icon" icon={finalIcon}/>
      <p>{text}</p>
    </div>
  );
};

export default IconTextGeneric;

const container = css`
  color: ${colors.inputTextColor};
  display: flex;
  align-items: center;
  font-size: ${textSizes.normal};
  opacity: .5;
  transition-duration: .2s;
  margin-top: 30px;
  
  &:hover {
    opacity: 1;
  }
  
  .icon {
    font-size: 16px;
  }
  
  p {
    padding: 0 6px;
    margin-left: 18px;
  }
`;
